import { Injectable } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngxs/store';
import { SetInitialStateFacade, LoadDataFacade } from '../../../../../common/models';
import { Observable } from 'rxjs';
import { AllocationDriverViewProfile, AllocationViewProfile } from '../models';
import { AllocationViewProfileItemState } from './allocation-view-profile-item.state';
import {
  AllocationViewProfileItemLoadDefault,
  AllocationViewProfileItemLoad,
  AllocationViewProfileItemSave,
  AllocationViewProfileItemDelete,
  AllocationViewProfileItemInitialState,
  AllocationViewProfileItemDriverViewLoad,
} from './allocation-view-profile-item.actions';

import { ConfirmationDialogAfterClosedModel } from '../../../../../ui-kit';

@Injectable({ providedIn: 'root' })
export class AllocationViewProfileItemFacade implements SetInitialStateFacade, LoadDataFacade {
  loaded$: Observable<boolean> = this.store.select(AllocationViewProfileItemState.getLoaded);
  profile$: Observable<AllocationViewProfile> = this.store.select(AllocationViewProfileItemState.getProfile);
  id$: Observable<number> = this.store.select(AllocationViewProfileItemState.getProfileId);
  defaultProfile$: Observable<AllocationViewProfile> = this.store.select(
    AllocationViewProfileItemState.getDefaultProfile,
  );
  defaultProfileLoaded$: Observable<boolean> = this.store.select(AllocationViewProfileItemState.getProfileLoaded);
  driverViewProfile$: Observable<AllocationDriverViewProfile> = this.store.select(
    AllocationViewProfileItemState.getDriverViewProfile,
  );
  driverViewProfileLoaded$: Observable<boolean> = this.store.select(
    AllocationViewProfileItemState.getDriverViewProfileLoaded,
  );

  constructor(private store: Store) {}

  loadAll(id: number): void {
    this.store.dispatch(new AllocationViewProfileItemLoad(id));
  }

  getDefaultProfile(): void {
    this.store.dispatch(new AllocationViewProfileItemLoadDefault());
  }

  saveProfile(profile: AllocationViewProfile): void {
    this.store.dispatch(new AllocationViewProfileItemSave(profile));
  }

  deleteProfile(id: number, dialogRef: MatDialogRef<ConfirmationDialogAfterClosedModel>): void {
    this.store.dispatch(new AllocationViewProfileItemDelete(id, dialogRef));
  }

  setInitialState(): void {
    this.store.dispatch(new AllocationViewProfileItemInitialState());
  }

  loadDriverViewProfile(id: number): void {
    this.store.dispatch(new AllocationViewProfileItemDriverViewLoad(id));
  }
}
